import React, { useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Tooltip,
  IconButton,
} from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import CopyToClipboard from "react-copy-to-clipboard";
import { useSelector } from "react-redux";
import CustomizedSnackbars from "../components/snackbar";
import { BootstrapButton } from "../components/styledcomponents";

function FundAccount() {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const savingsinfo = useSelector((state) => state.savingsInfos);

  const handleCopyClick = (message) => {
    setSnackbarMessage(message);
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const usdtErc20Address = "0x6789E3f7d801a8A3F96b42E7EA515161046B54B0";
  const accountNumber = savingsinfo?.accountnumber || "****";

  return (
    <Box sx={{ mt: 2 }}>
      <CustomizedSnackbars
        openSnackbar={openSnackbar}
        handleCloseSnackbar={handleCloseSnackbar}
        severity="success"
        message={snackbarMessage}
      />

      <Box sx={{ mb: 2 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: "#0d47a1", mb: 0.5 }}>
          Fund Your Account
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Choose a funding method and copy the details to complete your top-up.
        </Typography>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Paper elevation={1} sx={{ borderRadius: 2, p: 2, backgroundColor: "#fff" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
              Account Number Deposit
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Use this account number for deposits to fund your wallet balance.
            </Typography>
            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                border: "1px solid #e5eaf5",
                backgroundColor: "#f6f9ff",
                mb: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              <Typography
                variant="body1"
                sx={{ fontWeight: 700, fontFamily: "monospace" }}
              >
                {accountNumber}
              </Typography>
              <CopyToClipboard text={accountNumber} onCopy={() => handleCopyClick("Account number copied")}>
                <Tooltip title="Copy account number">
                  <IconButton size="small">
                    <ContentCopy fontSize="small" />
                  </IconButton>
                </Tooltip>
              </CopyToClipboard>
            </Box>
            <CopyToClipboard text={accountNumber} onCopy={() => handleCopyClick("Account number copied")}>
              <BootstrapButton fullWidth variant="contained" disableElevation sx={{ textTransform: "none" }}>
                Copy Account Number
              </BootstrapButton>
            </CopyToClipboard>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper elevation={1} sx={{ borderRadius: 2, backgroundColor: "#fff" }}>
            <Box sx={{ p: 2 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                USDT ERC20 Deposit
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Send USDT (ERC20) to this address and it will be credited to your account.
              </Typography>
              <Box
                sx={{
                  p: 2,
                  borderRadius: 2,
                  border: "1px solid #e5eaf5",
                  backgroundColor: "#f6f9ff",
                  mb: 2,
                  wordBreak: "break-all",
                }}
              >
                <Typography variant="body2" sx={{ fontFamily: "monospace", fontWeight: 600 }}>
                  {usdtErc20Address}
                </Typography>
              </Box>
              <CopyToClipboard text={usdtErc20Address} onCopy={() => handleCopyClick("USDT ERC20 address copied")}>
                <BootstrapButton fullWidth variant="contained" disableElevation sx={{ textTransform: "none" }}>
                  Copy USDT ERC20 Address
                </BootstrapButton>
              </CopyToClipboard>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper elevation={1} sx={{ borderRadius: 2, p: 2, backgroundColor: "#fff" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
              Funding tips
            </Typography>
            <Box component="ul" sx={{ pl: 2, m: 0, color: "text.secondary" }}>
              <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                Use the exact details shown above for every deposit.
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                For crypto transfers, double-check the address before sending.
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                Deposits typically appear in your account within 24 hours.
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default FundAccount;
